import React from 'react';
import PropTypes from 'prop-types';
import HeadShot from '../../_atoms/Headshot';
import fonts from '@general/fonts';

export default function HeadshotArray({ hits, numToShow = 5 }) {
    if (hits.length === 0) return null;

    const moreText = hits.length > numToShow ? `+${hits.length - numToShow} more` : null;

    return (
        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row' }}>
            {hits.slice(0, numToShow).map(hit => (
                <HeadShot key={hit.objectID} firstName={hit.firstName} lastName={hit.lastName} imgUrl={hit.photoUrl} />
            ))}
            {moreText && <span style={{ fontFamily: fonts.sans }}>{moreText}</span>}
        </div>
    );
}

HeadshotArray.propTypes = {
    hits: PropTypes.array,
    numToShow: PropTypes.number,
};
